import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d37d1b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Task" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-guanyuxitong" }, null, -1))
const _hoisted_4 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_5 = {
  key: 0,
  style: {"margin-left":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_ComboGrid = _resolveComponent("ComboGrid")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_EditTable = _resolveComponent("EditTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.form,
      rules: _ctx.rules,
      "label-width": "140px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('task.form.code'),
                  prop: "code"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.code,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.code) = $event)),
                      placeholder: _ctx.$t('task.form.code_placeholder'),
                      maxlength: "20",
                      disabled: _ctx.disabled,
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('task.form.name'),
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                      placeholder: _ctx.$t('task.form.name_placeholder'),
                      maxlength: "100",
                      disabled: _ctx.disabled,
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('task.form.taskKey'),
                  prop: "taskKey"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ComboGrid, {
                      ref: el=>_ctx.refMap.set('taskKey',el),
                      modelValue: _ctx.form.taskKey,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.taskKey) = $event)),
                      params: _ctx.comboGridParam({comboId:'taskKey'})
                    }, null, 8, ["modelValue", "params"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('task.form.cron'),
                  prop: "cron"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.cron,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.cron) = $event)),
                      placeholder: _ctx.$t('task.form.cron_placeholder'),
                      maxlength: "100",
                      disabled: _ctx.disabled,
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('task.form.status'),
                  prop: "status"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.form.status,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.status) = $event)),
                      disabled: _ctx.disabled,
                      "active-value": "true"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('task.form.excuteNum'),
                  prop: "excuteNum"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.form.excuteNum,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.excuteNum) = $event)),
                      min: 0,
                      max: 9999999,
                      disabled: "disabled",
                      controls: false,
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('task.form.limitExcuteNum'),
                  prop: "limitExcuteNum"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.form.limitExcuteNum,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.limitExcuteNum) = $event)),
                        min: -1,
                        max: 9999999,
                        disabled: _ctx.disabled,
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: _ctx.$t('task.form.limitExcuteNum_tip'),
                        placement: "top-start"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('task.form.desc'),
                  prop: "desc"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      modelValue: _ctx.form.desc,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.desc) = $event)),
                      placeholder: _ctx.$t('task.form.desc_placeholder'),
                      maxlength: "255",
                      disabled: _ctx.disabled,
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_EditTable, _mergeProps({
      ref: el=>_ctx.refMap.set('taskParams',el)
    }, _ctx.cardDetailParam('taskParams'), {
      "parent-inst": this,
      beforeEndEdit: _ctx.beforeEndEdit
    }), {
      tbCols: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('task.taskParams.F_NAME'),
          prop: "F_NAME"
        }, {
          default: _withCtx((scope) => [
            (!scope.row.EDIT)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row.F_NAME), 1))
              : (_openBlock(), _createBlock(_component_el_input, {
                  key: 1,
                  placeholder: _ctx.$t('task.taskParams.F_NAME_placeholder'),
                  modelValue: scope.row.F_NAME,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.F_NAME) = $event),
                  clearable: ""
                }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('task.taskParams.F_VALUE'),
          prop: "F_VALUE"
        }, {
          default: _withCtx((scope) => [
            (!scope.row.EDIT)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(scope.row.F_VALUE), 1))
              : (_openBlock(), _createBlock(_component_el_input, {
                  key: 1,
                  placeholder: _ctx.$t('task.taskParams.F_VALUE_placeholder'),
                  modelValue: scope.row.F_VALUE,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.F_VALUE) = $event),
                  clearable: ""
                }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 16, ["beforeEndEdit"])
  ]))
}